import { useContext } from "react";
import AuthContext from "../../../context/AuthContext";
import useCustomForm from "../../../hooks/useCustomForm";
import "../UserAccess.css";
import AccessContainer from "../AccessContainer";
import RegisterFormContent from "./FormContent";
const RegisterContent = () => {
  const { registerUser } = useContext(AuthContext);
  const defaultValues = {
    username: "",
    email: "",
    password: "",
    firstName: "",
    lastName: "",
  };
  const [formData, handleInputChange, handleSubmit] = useCustomForm(
    defaultValues,
    registerUser,
  );
  return (
    <AccessContainer>
      <RegisterFormContent
        formData={formData}
        handleInputChange={handleInputChange}
        handleSubmit={handleSubmit}
      />
    </AccessContainer>
  );
};

export default RegisterContent;
